module.exports = "<div class=\"b-park-meter\">\n  <div class=\"b-park-meter__outer\">\n    <div class=\"b-park-meter__inner\"\n         [ngStyle]=\"{'height.%': quantity, 'background': quantity >= 30 ? '#28a745' : '#dc3545'}\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/meter/park-meter.html
// module id = ./src/app/dashboard/parks/park/meter/park-meter.html
// module chunks = main